import { render, staticRenderFns } from "./PrimaryNavigation.vue?vue&type=template&id=52cdfe8e&scoped=true&"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNavigation.vue?vue&type=style&index=0&id=52cdfe8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdfe8e",
  null
  
)

export default component.exports